// import { DotButton } from "./EmblaCarouselDotButton";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { usePrevNextButtons } from "./EmblaCarouselArrowButtons";
import useEmblaCarousel from "embla-carousel-react";

const EventCarousel = ({ slides }) => {
  //   const slides = [1, 2, 3, 4, 5];
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });

  //   const { selectedIndex, scrollSnaps, onDotButtonClick } =
  //     useDotButton(emblaApi);

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <section className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {slides.map((item, index) => (
            <div className="embla__slide" key={index}>
              <div className="embla__slide__number">
                <img src={item?.event_image_url} alt="event" />
              </div>
            </div>
          ))}
        </div>
        {slides.length > 1 && (
          <>
            {" "}
            <button
              className="prev__event__btn"
              onClick={onPrevButtonClick}
              disabled={prevBtnDisabled}
            >
              <ArrowLeft strokeWidth={1.5} />
            </button>
            <button
              className="next__event__btn"
              onClick={onNextButtonClick}
              disabled={nextBtnDisabled}
            >
              <ArrowRight strokeWidth={1.5} />
            </button>
          </>
        )}
      </div>
    </section>
  );
};

export default EventCarousel;
